import axios from 'axios'
import AscentiaService from './ascentiaService'
import Qs from 'qs'
import { saveAs } from 'file-saver'
import moment from 'moment'

const values = {
  airlinesData: null,
  masterModelsData: null,
  tailsData: null,
  systemsData: null,
  reportTypesData: null,
  parameterNamesData: null,
  reportData: null,
  aircraftDetails: null,
  parameterDefinition: null,
  parameterGraph: null,
  fleetGraph: null,
  nextReportId: null,
  reportListData: null,
  exportedReportsGivenId: null,
  reportExportGivenOptions: null,
  apuCycleExportGivenOptions: null,
  faultMonitorExportGivenOptions: null,
  fleetAlertsExportGivenOptions: null,
  fleetMessagesExportGivenOptions: null,
  eventReportListData: null,
  graphGroupsPerReportType: null,
  reportPlotGraphGroups: null,
}

const getters = {
  airlinesData() {
    const url = '/Acmf/airlines'
    return axios.get(url)
  },
  masterModelsData() {
    const url = '/Acmf/mastermodels'
    return axios.get(url)
  },
  tailsData() {
    const url = '/Acmf/tails'
    return axios.get(url)
  },
  systemsData() {
    const url = '/Acmf/systems'
    return axios.get(url)
  },
  reportTypesData() {
    const url = '/Acmf/ReportTypes'
    return axios.get(url)
  },
  parameterNamesData() {
    const url = '/Acmf/ParameterNames'
    return axios.get(url)
  },
  reportData({ reportId, tailNumber }) {
    const url = `/Acmf/TailNumber/${tailNumber}/Report/${reportId}`
    return axios.get(url)
  },
  reportTimeLinesData({
    currentReportId,
    recordCountBefore,
    recordCountAtAndAfter,
  }) {
    const queryString = `reportId=${currentReportId}&recordCountBefore=${recordCountBefore}&recordCountAtAndAfter=${recordCountAtAndAfter}`
    const url = `/Acmf/AcmfReportTimeLines?${queryString}`
    return axios.get(url)
  },
  aircraftDetails(tailNumber) {
    const url = `/Acmf/TailNumber/${tailNumber}`
    return axios.get(url)
  },
  parameterDefinition({ id, tailNumber, isDataElementId, reportNumber }) {
    const params = {
      isDataElementId,
      reportNumber,
    }
    const url = `/Acmf/ParameterDefinition/${id}/TailNumber/${tailNumber}`
    return axios.get(url, {
      params,
      paramSerializer: Qs.stringify(params),
    })
  },
  parameterGraph({
    tailNumber,
    parameterId,
    startDate,
    endDate,
    isDataElementId,
    reportNumber,
  }) {
    const params = {
      startDate,
      endDate,
      isDataElementId,
      reportNumber,
    }
    const url = `/Acmf/ParameterValues/TailNumber/${tailNumber}/Parameter/${parameterId}`
    return axios.get(url, {
      params,
      paramSerializer: Qs.stringify(params),
    })
  },
  fleetGraph({ parameterId, tailNumber, startDate, endDate, index = -1 }) {
    let url = `/Acmf/FleetComparison/parameterId/${parameterId}/tailNumber/${tailNumber}?startDate=${startDate}&endDate=${endDate}`
    if (index > -1) {
      url += `&seriesDataIndex=${index}`
    }
    return axios.get(url)
  },
  rawReport(reportId) {
    const url = `/Acmf/RawReport/${reportId}`
    return axios.get(url)
  },
  nextReportId({ currentReportId, ascending }) {
    const url = `/Acmf/ReportIds/${currentReportId}?ascending=${ascending}`
    return axios.get(url)
  },
  reportListData(queryString) {
    const url = `/Acmf/ReportList/${queryString}`
    return axios.get(url)
  },
  exportedReportsGivenId(reportId) {
    const queryString = `ReportId=${reportId}`
    const url = `/Acmf/Export?${queryString}`
    return axios
      .get(url, {
        headers: { Accept: 'application/vnd.ms-excel' },
        responseType: 'blob',
      })
      .then(response => {
        const formattedDate = moment().format('YYYY-MM-DD_HH-mm-ss')
        const fileName = `Export_${formattedDate}.xlsx`
        saveAs(response.data, fileName)
      })
  },
  reportExportGivenOptions({
    startDate,
    endDate,
    reportType,
    airlineNames,
    tailNumbers,
    isReducedApuList,
  }) {
    const airlineIds =
      airlineNames.length === 0
        ? []
        : airlineNames.split(',').map(item => parseInt(item))
    const tailIds =
      tailNumbers.length === 0
        ? []
        : tailNumbers.split(',').map(item => parseInt(item))
    const url = `/Acmf/ExportDateRange`
    return axios
      .post(
        url,
        {
          startDate,
          endDate,
          reportNumber: reportType,
          airlines: airlineIds,
          tails: tailIds,
          isReducedApuList,
        },
        {
          headers: { Accept: 'application/vnd.ms-excel' },
          responseType: 'blob',
        },
      )
      .then(response => {
        const formattedDate = moment().format('YYYY-MM-DD_HH-mm-ss')
        const fileName = `Export_${formattedDate}.xlsx`
        saveAs(response.data, fileName)
      })
  },
  apuCycleExportGivenOptions({ reportDate, airlineIds, masterModelNames }) {
    let queryString = `ReportDate=${reportDate}`
    if (airlineIds.length > 0) {
      airlineIds.split(',').forEach(item => {
        queryString += `&Airlines=${item}`
      })
    }
    if (masterModelNames.length > 0) {
      masterModelNames.split(',').forEach(item => {
        queryString += `&MasterModels=${item}`
      })
    }
    const url = `/AcmfFleetExport/APUCycles?${queryString}`
    return axios
      .get(url, {
        headers: { Accept: 'application/vnd.ms-excel' },
        responseType: 'blob',
      })
      .then(response => {
        const formattedDate = moment().format('YYYY-MM-DD_HH-mm-ss')
        const fileName = `Export_${formattedDate}.xlsx`
        saveAs(response.data, fileName)
      })
  },
  faultMonitorExportGivenOptions({ startDate, endDate, airlineIds }) {
    let queryString = `StartDate=${startDate}&EndDate=${endDate}`
    if (airlineIds.length > 0) {
      airlineIds.split(',').forEach(item => {
        queryString += `&Airlines=${item}`
      })
    }
    const url = `/AcmfFleetExport/FaultMonitor?${queryString}`
    return axios
      .get(url, {
        headers: { Accept: 'application/vnd.ms-excel' },
        responseType: 'blob',
      })
      .then(response => {
        const formattedDate = moment().format('YYYY-MM-DD_HH-mm-ss')
        const fileName = `Export_${formattedDate}.xlsx`
        saveAs(response.data, fileName)
      })
  },
  fleetAlertsExportGivenOptions({
    startDate,
    endDate,
    airlineIds,
    masterModelNames,
  }) {
    let queryString = `StartDate=${startDate}&EndDate=${endDate}`
    if (airlineIds.length > 0) {
      airlineIds.split(',').forEach(item => {
        queryString += `&Airlines=${item}`
      })
    }
    if (masterModelNames.length > 0) {
      masterModelNames.split(',').forEach(item => {
        queryString += `&MasterModels=${item}`
      })
    }
    const url = `/AcmfFleetExport/FleetAlertReport?${queryString}`
    return axios
      .get(url, {
        headers: { Accept: 'application/vnd.ms-excel' },
        responseType: 'blob',
      })
      .then(response => {
        const formattedDate = moment().format('YYYY-MM-DD_HH-mm-ss')
        const fileName = `Export_${formattedDate}.xlsx`
        saveAs(response.data, fileName)
      })
  },
  fleetMessagesExportGivenOptions({
    startDate,
    endDate,
    airlineIds,
    ataChapterIds,
  }) {
    let queryString = `StartDate=${startDate}&EndDate=${endDate}`
    if (airlineIds.length > 0) {
      airlineIds.split(',').forEach(item => {
        queryString += `&Airlines=${item}`
      })
    }
    if (ataChapterIds.length > 0) {
      ataChapterIds.split(',').forEach(item => {
        queryString += `&AtaChapters=${item}`
      })
    }
    const url = `/AcmfFleetExport/FleetMessages?${queryString}`
    return axios
      .get(url, {
        headers: { Accept: 'application/vnd.ms-excel' },
        responseType: 'blob',
      })
      .then(response => {
        const formattedDate = moment().format('YYYY-MM-DD_HH-mm-ss')
        const fileName = `Export_${formattedDate}.xlsx`
        saveAs(response.data, fileName)
      })
  },
  graphGroupsPerReportType() {
    const url = '/AcmfGraphing/GraphGroupsPerReportType'
    return axios.get(url)
  },
  reportPlotGraphGroups({ graphGroupId, tailNumber, startDate, endDate }) {
    let url = `/AcmfGraphing/GraphGroupValues/GraphGroup/${graphGroupId}/TailNumber/${tailNumber}`
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`
    }
    return axios.get(url)
  },
  reportPlotGraph({ graphId, tailNumber, startDate, endDate }) {
    let url = `/AcmfGraphing/GraphValues/GraphId/${graphId}/TailNumber/${tailNumber}`
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`
    }
    return axios.get(url)
  },
}

const saves = {
  eventReportListData(eventReportParams) {
    const url = '/AcmfEvent/AcmfEvents'
    return axios.post(url, eventReportParams)
  },
}
export default class AcmfService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
